import type { UiSheetProps } from "@frontend/roz-uikit";
import type { ReactNode } from "react";

import { cn } from "@/lib/cn";
import type { SheetContentType } from "@/types";

export const closeButtonByType = (
  type: SheetContentType
): ReactNode | undefined => {
  switch (type) {
    case "menu": {
      return null;
    }
    default: {
      return;
    }
  }
};

export const classNameByType = (type: SheetContentType) =>
  cn(
    type === "menu" &&
      "sdkui:!border-0 sdkui:!bg-transparent sdkui:!p-0 sdkui:!shadow-none sdkui:!w-full sdkui:!max-w-full sdkui:max-md:!inset-0 sdkui:max-md:!h-dvh sdkui:max-md:!w-screen sdkui:max-md:!min-w-screen sdkui:max-md:!max-w-screen sdkui:max-md:!rounded-none sdkui:md:!w-auto sdkui:md:!max-w-fit sdkui:overflow-visible",
    type === "region-select" && "sdkui:flex sdkui:flex-col"
  );

export const sideByType = (type: SheetContentType): UiSheetProps["side"] => {
  switch (type) {
    case "region-select": {
      return "left";
    }
    default: {
      return "right";
    }
  }
};
